module.exports = __webpack_public_path__ + "img/xyz_logo.ed7acb18.png";